// extracted by mini-css-extract-plugin
module.exports = {"HorizontalTiles":"HorizontalTiles-module__HorizontalTiles___2nLtA"};